import { render, staticRenderFns } from "./PluginAlert.vue?vue&type=template&id=4d893178&"
import script from "./PluginAlert.vue?vue&type=script&lang=js&"
export * from "./PluginAlert.vue?vue&type=script&lang=js&"
import style0 from "./PluginAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports